export { ElectricIcon } from './electric'
